// deps
import React, { memo, ReactElement, useCallback, useMemo } from "react";

// interfaces
import { CardPaymentMethodData, ICardPaymentGroup } from "@payment-ui/interfaces/Card";
import { PaymentMethodProps } from "@payment-ui/interfaces";

//components
import PaymentMethodIcon from "@payment-ui/widgets/payment-method-icon/PaymentMethodIcon";
import OtherPaymentOffersGenericUI from "../../OtherPaymentOffersGenericUI";

// helpers
import {
    canEnablePaymentMethod,
    getPaymentMethodDisplayName,
    getPaymentMethodDiscount,
    getPaymentMethodIconUrl,
} from "@payment-ui/helpers/Payment";

const CARD_PAYMENT_ICON_WIDTH = 32;

interface Props extends PaymentMethodProps {
    key: string;
    methodData: CardPaymentMethodData;
    paymentActions: ICardPaymentGroup["paymentActions"];
    nonTokenizeCardRemovalMsg?: string;
}

function NewCardPaymentMethod(props: Props): React.ReactElement {
    const displayName = getPaymentMethodDisplayName(props.methodData);
    const subtext = getPaymentMethodDiscount(props.methodData);

    const isMethodEnabled = useMemo(() => canEnablePaymentMethod(props.methodData, props.isPaymentGroupEnabled), [
        props.isPaymentGroupEnabled,
        props.methodData,
    ]);
    const { onSelect } = props.paymentActions;

    const onClick = useCallback(
        (e: React.MouseEvent): void => {
            e.preventDefault();
            isMethodEnabled && onSelect(props.methodData);
        },
        [onSelect, props.methodData, isMethodEnabled],
    );

    const paymentMethodIcon = useMemo(
        (): ReactElement => (
            <PaymentMethodIcon
                src={getPaymentMethodIconUrl(props.methodData)}
                alt={props.methodData.displayName}
                width={CARD_PAYMENT_ICON_WIDTH}
            />
        ),
        [props.methodData],
    );

    return (
        <OtherPaymentOffersGenericUI
            onClick={onClick}
            displayName={displayName}
            subtext={subtext}
            paymentMethodIcon={paymentMethodIcon}
        />
    );
}

export default memo(NewCardPaymentMethod);
